module.exports = __webpack_public_path__ + "static/media/case5.d2f83dc4.jpg";